import React from 'react';
import { listContainerStyle, sectionHeaderStyle } from './styles';

interface SpawnPointDetailsProps {
  spawnPoints: any[];
}

export const SpawnPointDetails: React.FC<SpawnPointDetailsProps> = ({ spawnPoints }) => {
  return (
    <>
      <div style={sectionHeaderStyle}>Spawn Points ({spawnPoints.length})</div>
      <div style={{ ...listContainerStyle, marginBottom: 0 }}>
        {spawnPoints.length === 0 ? (
          <div style={{ fontSize: '11px', color: '#666', textAlign: 'center' }}>No spawn points</div>
        ) : (
          spawnPoints.map((sp, i) => (
            <div key={i} style={{ fontSize: '11px', color: '#aaa', padding: '2px 0' }}>
              <span style={{ color: '#888', marginRight: '5px' }}>#{i + 1}</span>
              <span style={{ fontFamily: 'monospace' }}>({sp.x}, {sp.y})</span>
              {sp.id && <span style={{ color: '#555', marginLeft: '10px', fontSize: '10px' }}>[{sp.id}]</span>}
            </div>
          ))
        )}
      </div>
    </>
  );
};
